<template>
	<div class="big-btn">
		<van-button @click="onBtnClick" round>{{ txt }}</van-button>
	</div>
</template>

<script>
	export default {
		name: "bigBtn",
		props: {
			txt: {
				type: String,
				default: 'text'
			}
		},
		methods: {
			onBtnClick () {
				this.$emit ( 'onBtnClick' )
			}
		}
	}
</script>

<style lang="less">
	.big-btn {
		padding-top: 40px;
		.van-button {
			width: 500px;
			height: 88px;
			border-color: var(--epButtonColor);
			background-color: var(--epButtonColor);
			border-radius: 40px;
			font-size: 24px;
			font-weight: bold;
			color: var(--epTextColor);
		}
	}
	
</style>